export default __webpack_public_path__ + "static/media/male_hips.654ea894.png";